// Kuraterede diktat-enheder til ekstraøvelsen Orddiktat.
// Banken genereres fra seed-sætninger + ordmanifest:
//   npm run dictation:units:build        (dansk)
//   npm run dictation:units:en:build     (engelsk)
// Verificér før ElevenLabs:
//   npm run dictation:units:verify
//   npm run dictation:units:en:verify

import type { CurriculumTierId } from '../../types';
import { DICTATION_UNITS_GENERATED } from './dictationUnits.generated';
import { DICTATION_UNITS_EN_GENERATED } from './dictationUnits.en.generated';

export interface DictationUnit {
  id: string;
  text: string;
  wordCount: number;
  minTierId?: CurriculumTierId;
  tags?: string[];
}

/** Adskiller enheder i én ekstra-diktat-session. */
export const DICTATION_UNIT_SEPARATOR = '\n\n';

/** Antal enheder pr. ekstra orddiktat-session. */
export const EXTRA_DICTATION_SESSION_UNITS = 5;

export const DICTATION_UNITS_DA: DictationUnit[] = DICTATION_UNITS_GENERATED;
export const DICTATION_UNITS_ENGLISH: DictationUnit[] = DICTATION_UNITS_EN_GENERATED;

/** Default dictation unit bank (Danish) — kept for backwards imports. */
export const DICTATION_UNITS: DictationUnit[] = DICTATION_UNITS_DA;

/** Alle unikke enhedstekster til lyd-manifest. */
export function getDictationUnitTexts(locale: 'da' | 'en' = 'da'): string[] {
  const units = locale === 'en' ? DICTATION_UNITS_ENGLISH : DICTATION_UNITS_DA;
  const collator = locale === 'en' ? 'en' : 'da';
  return [...new Set(units.map((u) => u.text))].sort((a, b) =>
    a.localeCompare(b, collator),
  );
}
